<template>
  <div class="page-container">
    <div class="query-title">现金奖励项目</div>
  <div class="content">
    <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
    <div class="table-container">
      <Table-filter
        title="明细"
        :rt-columns="rtColumns1"
        :lt-columns="ltColumns1"
        :grid-columns="gridOptions.columns"
        :count-data="countFileds"
        :all-options="allOptions"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
        @confirm="tableConfigConfirm"
      >
        <template #button>
          <table-button name="add" tip="新增" @click="addDictRows()" />
          <table-button name="export" tip="修改" @click="editDictRows()" />
          <table-button name="export" tip="启用" @click="changeStatus('ENABLE')" />
          <table-button name="export" tip="禁用" @click="changeStatus('DISABLE')" />
          <table-button name="export" tip="导出" @click="exportExcel" />
        </template>
        <vxe-grid
          ref="xTable"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          height="300"
          max-height="600"
          align="center"
          size="mini"
          show-overflow
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :sort-config="{ multiple: true }"
          :empty-render="{name: 'NotData'}"
          :filter-config="{ remote: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          :row-class-name="rowClassName"
          @filter-change="filterChangeEvt"
        >
        <template #status="{ row }">
          <el-link
            size="mini"
            :type="row.status == 'V001' ? 'success' : 'danger'"
            effect="dark"
          >
            {{ row.status_text }}
          </el-link>
        </template>
        </vxe-grid>
      </Table-filter>
    </div>
  </div>
  <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
   <!-- 选择通用弹窗情况 -->
   <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="70%"
    >
      <DictEdit v-if="dialogVisible" ref="DictEdit" :mode="mode" :edit-rows="editRows" />
      <div slot="footer">
        <el-button size="small" type="default" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitHandle">保存</el-button>
      </div>
    </el-dialog>
</div>
</template>

<script>
import { getCashReward, cashReward } from '@/api/sap/reward-policy'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/rewardProject'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import DictEdit from './components/DictEdit.vue'
export default {
mixins: [tableMixins],
components: {
  DictEdit
},
data() {
  return {
    pageSearch,
    searchField: {},
    pagination: {
      page: 1,
      pagesize: 50,
      totalCount: 0
    },
    loading: false,
    gridOptions: {
      columns: [
        { type: 'checkbox', field: 'checkbox', title: '', width: 50, align: 'center' },
        ],
      data: []
    },
    dialogVisible: false,
    checkData: [],
    confirmBtn: '',
    mode: 'add',
    editRows: []
  }
},
props: {
},
created() {
  this.initPage(pageConfig)
},
computed: {
  dialogTitle() {
    return this.mode === 'add' ? '新增' : '编辑'
  }
},
methods: {
  async submitHandle(){
    const validData = this.$refs['DictEdit'].validRows()
    if (validData) {
      await this.requestApi(validData)
    }
  },
  async requestApi(pdata,mode) {
    const params = {
      user_bp: this.$store.getters.role.USER_BP,
      mode: this.mode === 'edit' ? 'UPDATE' : 'INSERT',
      data: pdata,
      mode: mode || (this.mode === 'edit' ? 'UPDATE' : 'INSERT'),
      data: pdata.map(item => {
        return {
          status: mode === 'ENABLE' ? 'V001' : 'V002',
          ...item
        }
      })
    }
    const { message, msgtype } = await cashReward(params)
    if (msgtype === 'S') {
      this.$message.success(message)
      this.dialogVisible = false
      this.queryData()
    } else {
      this.$message.error(message)
    }
  },
  async changeStatus(mode) {
    const data = this.$refs['xTable'].getCheckboxRecords()
    if (!data.length) {
      return this.$message.warning('请选择有效的数据！')
    }
    if (mode === 'DISABLE' && data.every(v => v.status == 'V002')) {
      return this.$message.warning('请选择已启用的数据！')
    } else if (mode === 'ENABLE' && data.every(v => v.status == 'V001')) {
      return this.$message.warning('请选择已禁用的数据！')
    }
    await this.requestApi(data, mode)
    this.queryData()
  },
  
  addDictRows() {
    this.editRows = []
    this.dialogVisible = true
    this.mode = 'add'
  },
  editDictRows() {
    this.editRows = []
    const data = this.$refs['xTable'].getCheckboxRecords()
    if (!data.length) {
      return this.$message.warning('请选择要修改的数据！')
    }

    if (data.some(v => v.status == 'V002')) {
      return this.$message.warning('请选择已启用的数据！')
    }
    this.editRows = JSON.parse(JSON.stringify(data))
    this.editRows.forEach(ele => {
      ele.start_date = this.formatDate(ele.start_date)
      ele.end_date = this.formatDate(ele.end_date)
    });
    this.dialogVisible = true
    this.mode = 'edit'
  },
  formatDate(date) {
    return date.replace(/^(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
  },
  // 导出全部 导出本页
  async exportExcel() {
    const checkData = this.$refs.xTable.getCheckboxRecords()
    if (checkData.length) {
      frontExport(this.gridOptions.columns, checkData, '现金奖励项目数据报表')
      return
    }
    const params = {
      user_bp: this.$store.getters.role.USER_BP,
      ...this.allConditions
    }
    const data = await concurrencyReq(this.pagination.totalCount, params, getCashReward)
    frontExport(this.gridOptions.columns, data, '现金奖励项目数据报表')
  },
  handleTablePaginationChange(pages) {
    Object.assign(this.pagination, pages)
    this.queryData()
  },
  async queryData(page, ranges) {
    if (page === 1) {
      this.pagination.page = page
      if (ranges) {
        // 保存 查询组件的查询参数
        this.ranges = ranges
        this.handleRanges(ranges)
      }
      this.isSetFilter = false
    }
    const params = {
      user_bp: this.$store.getters.role.USER_BP,
      role: this.$store.getters.role.ROLE,
      ...this.pagination,
      is_result: 1,
      sort: this.sortData.concat(this.tableSort),
      ...this.allConditions,
    }
    this.loading = true
    try {
      const { data, total,calculation, field } = await getCashReward(params)
      if (data.length === 0 && (total - 0)) {
        this.queryData(1, ranges)
        return
      }
      this.pagination.totalCount = total - 0
      this.calculation = this.filtercalculation(calculation)
      // 更新计算值
      this.updateCount()
      if (this.showHeader) {
        this.gridOptions.data = this.tableCountData.concat(data)
      } else {
        this.gridOptions.data = data.concat(this.tableCountData)
      }
      this.allOptions = this.filterAllOptions(field)
      this.setFilter()
    } catch (e) {
      //
    }
    this.loading = false
  },
},

}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/reward-policy/reward-project.vue